export const getOrganizationDetailFrag = `
    id
`;

export const getOrganizationSettingsFrag = `
    id
    organizationId
    key
    data
    active
    createdAt
    updatedAt
`;
